'use strict';

module.exports = function () {
    // helpers
    require('./fonts/font-awesome/css/font-awesome.css');
    require('./helpers/flags/flags16.css');
    require('./helpers/flags/flags32.css');
    require('./helpers/flags/flags16-bw.css');
    require('./helpers/flags/flags32-bw.css');
    // popup stylesheets
    require('./helpers/ngDialog.css');
    require('./helpers/ngDialog-theme-default.css');
    // pages
    require('./views/login.css');
    require('./views/changelog.css');
    // custom styles
    require('./main.scss');
}


/** WEBPACK FOOTER **
 ** ./src/system/assets/css/index.js
 **/